import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ValueProposition } from './components/ValueProposition';
import { ServicesGrid } from './components/ServicesGrid';
import { AboutUs } from './components/AboutUs';
import { Testimonials } from './components/Testimonials';
import { EducationalContent } from './components/EducationalContent';
import { ServiceArea } from './components/ServiceArea';
import { AreasOfService } from './components/AreasOfService';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Home Inspection Services Fort Myers & SW Florida | Crown Inspection Services';
    // Set meta description for SEO
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Crown Inspection Services — Southwest Florida's trusted home inspector since 2008. Wind mitigation, 4-point, roof & mold inspections in Fort Myers, Naples, Cape Coral. Same-day reports. Call 239-699-7080.");
    // Set Open Graph title for social sharing
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Home Inspection Services Fort Myers & SW Florida | Crown Inspection Services');
    // Set Open Graph description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', 'Licensed & insured home inspections in Southwest Florida. Wind mitigation, 4-point, roof certificates & mold inspections. Same-day reports. Serving Fort Myers, Naples, Cape Coral & beyond.');
  }, []);
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ValueProposition data-id="element-4" />
        <ServicesGrid data-id="element-5" />
        <AboutUs data-id="element-6" />
        <Testimonials data-id="element-7" />
        <EducationalContent data-id="element-8" />
        <AreasOfService data-id="element-9" />
        <ServiceArea data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}